module.exports = __webpack_public_path__ + "img/sbd-online.d7f0a84e.png";